/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exporting_ResultsInputs */

const en_exporting_results = /** @type {(inputs: Exporting_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporting results...`)
};

const fr_exporting_results = /** @type {(inputs: Exporting_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation des résultats...`)
};

const de_exporting_results = /** @type {(inputs: Exporting_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse werden exportiert...`)
};

const it_exporting_results = /** @type {(inputs: Exporting_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione dei risultati...`)
};

const ru_exporting_results = /** @type {(inputs: Exporting_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты экспорта...`)
};

const es_exporting_results = /** @type {(inputs: Exporting_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportando resultados...`)
};

const zh_cn2_exporting_results = /** @type {(inputs: Exporting_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在导出结果...`)
};

const ja_exporting_results = /** @type {(inputs: Exporting_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果をエクスポートしています...`)
};

const hi_exporting_results = /** @type {(inputs: Exporting_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिणामों का निर्यात किया जा रहा है...`)
};

const pt_pt2_exporting_results = /** @type {(inputs: Exporting_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportando resultados...`)
};

/**
* | output |
* | --- |
* | "Exporting results..." |
*
* @param {Exporting_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const exporting_results = /** @type {((inputs?: Exporting_ResultsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exporting_ResultsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_exporting_results(inputs)
	if (locale === "de") return de_exporting_results(inputs)
	if (locale === "it") return it_exporting_results(inputs)
	if (locale === "ru") return ru_exporting_results(inputs)
	if (locale === "es") return es_exporting_results(inputs)
	if (locale === "zh-CN") return zh_cn2_exporting_results(inputs)
	if (locale === "ja") return ja_exporting_results(inputs)
	if (locale === "hi") return hi_exporting_results(inputs)
	if (locale === "pt-PT") return pt_pt2_exporting_results(inputs)
	return en_exporting_results(inputs)
});